import { type UseFormSetValue, type UseFormWatch, type UseFormClearErrors } from "react-hook-form";
import { type ClientSelectOptions } from "@userFrontend/features/clientReview/components/ClientReviewInputs/type";
import { type ViolationReportFormData } from "./type";

type UseFormHandlersParams = {
  setValue: UseFormSetValue<ViolationReportFormData>;
  watch: UseFormWatch<ViolationReportFormData>;
  clearErrors: UseFormClearErrors<ViolationReportFormData>;
  setClient: (client: { clientName: string; clientId: number } | undefined) => void;
  setClientShop: (shop: { shopName: string; shopId: number } | undefined) => void;
  setCheckedJobEntryId: (id: number | null) => void;
  setClientErrorText: (text: string | undefined) => void;
  setIsShowSearchModal: (show: boolean) => void;
  setDisplaySearchText: (display: boolean) => void;
};

/**
 * フォームのイベントハンドラーを提供するカスタムフック
 */
export const useFormHandlers = (params: UseFormHandlersParams) => {
  const {
    setValue,
    clearErrors,
    setClient,
    setClientShop,
    setCheckedJobEntryId,
    setClientErrorText,
    setIsShowSearchModal,
    setDisplaySearchText,
  } = params;

  // 企業選択ハンドラー（フォームにも反映）
  const handleClientSelectWithForm: ClientSelectOptions = ({
    params: selectParams,
    clientName,
    clientShopName,
  }) => {
    // clientId（モーダルから選択）と jobEntryId（ラジオボタン）は両立しない
    if (selectParams.clientId) {
      setClient({ clientName, clientId: selectParams.clientId });
      setValue("clientId", selectParams.clientId);
      // モーダルから企業を選択した場合、ラジオボタンの選択を解除
      setCheckedJobEntryId(null);
      setValue("jobEntryId", undefined);
      // バリデーションエラーをクリア
      clearErrors(["clientId", "jobEntryId"]);
    }
    if (clientShopName && selectParams.clientShopId) {
      setClientShop({ shopName: clientShopName, shopId: selectParams.clientShopId });
      setValue("clientShopId", selectParams.clientShopId);
    } else {
      // 店舗が指定されていない場合は、既存の店舗情報をクリア
      setClientShop(undefined);
      setValue("clientShopId", undefined);
    }
    // jobEntryId が存在する場合は設定（リジョブ経由の求人応募）
    if (selectParams.jobEntryId !== undefined) {
      setCheckedJobEntryId(selectParams.jobEntryId);
      setValue("jobEntryId", selectParams.jobEntryId);
      // ラジオボタンから選択した場合、モーダルで選択した企業情報をクリア
      setClient(undefined);
      setValue("clientId", undefined);
      // バリデーションエラーをクリア
      clearErrors(["clientId", "jobEntryId"]);
    }
    setClientErrorText(undefined);
    setIsShowSearchModal(false);
    setDisplaySearchText(true);
  };

  return {
    handleClientSelectWithForm,
  };
};
